import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center">
              <Calculator className="w-6 h-6 text-blue-600" />
              <span className="ml-2 text-lg font-bold text-gray-800">Online Kalkulator</span>
            </Link>
            <p className="mt-2 text-sm text-gray-600">
              Besplatni online kalkulatori za svakodnevne izračune.
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
              Popularni Kalkulatori
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/pdv-kalkulator" className="text-sm text-gray-600 hover:text-blue-600">
                  PDV Kalkulator
                </Link>
              </li>
              <li>
                <Link to="/izracun-postotka" className="text-sm text-gray-600 hover:text-blue-600">
                  Izračun Postotka
                </Link>
              </li>
              <li>
                <Link to="/kalkulator-kredita" className="text-sm text-gray-600 hover:text-blue-600">
                  Kalkulator Kredita
                </Link>
              </li>
              <li>
                <Link to="/kalkulator-place" className="text-sm text-gray-600 hover:text-blue-600">
                  Kalkulator Plaće
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
              Korisne Poveznice
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sitemap" className="text-sm text-gray-600 hover:text-blue-600">
                  Mapa Stranice
                </Link>
              </li>
              <li>
                <Link to="/online-stoperica" className="text-sm text-gray-600 hover:text-blue-600">
                  Online Štoperica
                </Link>
              </li>
              <li>
                <Link to="/generator-lozinke" className="text-sm text-gray-600 hover:text-blue-600">
                  Generator Lozinke
                </Link>
              </li>
              <li>
                <Link to="/generator-slucajnih-brojeva" className="text-sm text-gray-600 hover:text-blue-600">
                  Generator Slučajnih Brojeva
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
              Pravne Informacije
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/pravila-privatnosti" className="text-sm text-gray-600 hover:text-blue-600">
                  Pravila Privatnosti
                </Link>
              </li>
              <li>
                <Link to="/uvjeti-koristenja" className="text-sm text-gray-600 hover:text-blue-600">
                  Uvjeti Korištenja
                </Link>
              </li>
              <li>
                <Link to="/pravila-kolacica" className="text-sm text-gray-600 hover:text-blue-600">
                  Pravila Kolačića
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            &copy; {currentYear} Online Kalkulator. Sva prava pridržana.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="mailto:kontakt@backspace-media.com" className="text-gray-500 hover:text-blue-600">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;